import { useEffect, useState } from "react";

/** antd's `md` breakpoint — below this the layout is treated as phone-width. */
const NARROW_MAX_WIDTH = 768;

/**
 * True on phone-width viewports, kept in sync as the window resizes.
 *
 * The header's right-hand group (spend, activity, search, tour, theme) plus a
 * full email address overflowed at 375 px: the balance overlapped the logo and
 * the email ran off-screen. Components use this to fold the optional controls
 * into the account menu rather than letting them collide.
 */
export function useIsNarrow(): boolean {
  const [isNarrow, setIsNarrow] = useState(
    () =>
      typeof window !== "undefined" && window.innerWidth < NARROW_MAX_WIDTH,
  );

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const query = window.matchMedia(`(max-width: ${NARROW_MAX_WIDTH - 1}px)`);
    const onChange = (event: MediaQueryListEvent) => setIsNarrow(event.matches);
    setIsNarrow(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isNarrow;
}

export default useIsNarrow;
